import ImageZoom from '../../commons/ImageZoom';
import './Diffuseur.css';

const Diffuseur = () => {
    return (
      <div className="portfolio">
        <header className="portfolio-header">
          <h1>kiosques avec diffuseurs de parfum</h1>
          <p>Présentation du projet innovant de kiosque interactif avec diffuseur de parfum intégré</p>
        </header>
  
        <section className="portfolio-section">
          <h2>Fonctionnalités</h2>
          <div className="portfolio-projects">
            <div className="project">
              <ImageZoom style={{height: '200px', width: 'auto'}} alt={''} src={'./assets/diffuseur1.jpg'}/>
              <h3 className='mt-3'>Interaction avec la lumière LED</h3>
              <p>Chaque kiosque est équipée de LED interactives qui réagissent aux actions des utilisateurs, créant une ambiance immersive avant même que le parfum ne soit diffusé.</p>
            </div>
            <div className="project">
              <ImageZoom style={{height: '200px', width: 'auto'}} alt={''} src={'./assets/diffuseur2.jpeg'}/>
              <h3 className='mt-3'>Diffusion de parfum personnalisée</h3>
              <p>Grâce à un système intégré, l'utilisateur peut choisir le parfum qu'il souhaite tester et le diffuseur se met en marche automatiquement, enrichissant l'expérience sensorielle.</p>
            </div>
          </div>
        </section>
  
        <section className="portfolio-section">
          <h2>À propos du projet</h2>
          <p>
          Ce projet consistait à concevoir des bornes interactives intégrant un diffuseur de parfum pour offrir une expérience multisensorielle aux utilisateurs. 
          <br />
          Chaque borne est équipée d’un Raspberry Pi 4, qui contrôle l'ensemble des fonctionnalités via des GPIO. Ce système permet de gérer l’interaction avec des LED pour créer des effets lumineux dynamiques en fonction des actions des utilisateurs.
          <br />
          Lorsqu'un utilisateur s'approche de la borne, des lumières LED s’allument pour attirer son attention, et un menu interactif s’affiche sur un écran tactile. Il peut alors choisir parmi plusieurs options de parfums, et dès sa sélection, le diffuseur de parfum se lance automatiquement pour libérer la senteur choisie.
          <br />
          Le système utilise des capteurs de proximité et de pression pour détecter l’interaction de l'utilisateur avec l'interface tactile. Les LED changent de couleur en fonction des actions effectuées, et un moteur de diffusion de parfum est activé à l’aide des GPIO du Raspberry Pi.
          <br />
          Le matériel Android utilisé dans ce projet permet une interface utilisateur fluide et intuitive, tandis que le Raspberry Pi gère la partie matérielle pour un contrôle précis des composants.
          <br />
          Ce projet a pour but de créer une expérience immersive et engageante en combinant la technologie des bornes interactives avec l’activation d’un diffuseur de parfum en temps réel, rendant l’interaction avec le produit ludique et mémorable.
          </p>
        </section>
  
        <footer className="portfolio-footer">
          <a href="mailto:julien.j.1999@hotmail.com">Contactez-moi: julien.j.1999@hotmail.com</a>
        </footer>
      </div>
    );
  };
  
  export default Diffuseur;
